import { useLocation, matchPath } from 'react-router';

import CompaniesContainer from './CompaniesContainer';
import CompanyDetails from './CompaniesContainer/companiesDetails';
import NewCompany from './CompaniesContainer/newCompany';
import LocationsContainer from './LocationsContainer';
import LocationDetail from './LocationsContainer/locationDetail';
import NewLocation from './LocationsContainer/newLocation';
import TurbinesContainer from './TurbinesContainer';
import NewTurbine from './TurbinesContainer/newTurbine';
import TurbineDetails from './TurbinesContainer/turbineDetails';
import UsersContainer from './UsersContainer';
import NewUser from './UsersContainer/newUser';
import UserDetails from './UsersContainer/userDetails';
import { adminToolPaths } from '@/constants/adminTool';
import { adminToolRoutes } from '@/utils/adminTool';

function AdminToolContainer() {
  const location = useLocation();

  const renderTabContent = () => {
    const adminToolRoute = adminToolRoutes.find(route =>
      matchPath(route, location.pathname)
    );

    switch (adminToolRoute) {
      case adminToolPaths.users.root || adminToolPaths.root:
        return <UsersContainer />;
      case adminToolPaths.users.newUser:
        return <NewUser />;
      case adminToolPaths.users.detail:
        return <UserDetails />;
      case adminToolPaths.locations.root:
        return <LocationsContainer />;
      case adminToolPaths.locations.newLocation:
        return <NewLocation />;
      case adminToolPaths.locations.detail:
        return <LocationDetail />;
      case adminToolPaths.turbines.root:
        return <TurbinesContainer />;
      case adminToolPaths.turbines.newTurbine:
        return <NewTurbine />;
      case adminToolPaths.turbines.detail:
        return <TurbineDetails />;
      case adminToolPaths.companies.root:
        return <CompaniesContainer />;
      case adminToolPaths.companies.newCompany:
        return <NewCompany />;
      case adminToolPaths.companies.detail:
        return <CompanyDetails />;
      default:
        return <div>No content found</div>;
    }
  };

  return renderTabContent();
}

export default AdminToolContainer;
